export class CommentsPermissions {
	see: boolean;
	add: boolean;
	destroyOwnComments: boolean;
	editOwnComments: boolean;
	destroyOtherComments: boolean;
	editOtherComments: boolean;
	pin: boolean;

	constructor( {
		see = false,
		add = false,
		destroyOwnComments = false,
		editOwnComments = false,
		destroyOtherComments = false,
		editOtherComments = false,
		pin = false
	} ) {
		this.see = see;
		this.add = add;
		this.destroyOwnComments = destroyOwnComments;
		this.editOwnComments = editOwnComments;
		this.destroyOtherComments = destroyOtherComments;
		this.editOtherComments = editOtherComments;
		this.pin = pin;
	}
}

export const ownerCommentsPermissions = new CommentsPermissions( {
	see: true,
	add: true,
	destroyOwnComments: true,
	editOwnComments: true,
	destroyOtherComments: true,
	editOtherComments: false,
	pin: true
} );

export const projectManagerCommentsPermissions = new CommentsPermissions( {
	see: true,
	add: true,
	destroyOwnComments: true,
	editOwnComments: true,
	destroyOtherComments: true,
	editOtherComments: false,
	pin: true
} );

export const projectEditorCommentsPermissions = new CommentsPermissions( {
	see: true,
	add: true,
	destroyOwnComments: true,
	editOwnComments: true,
	destroyOtherComments: true,
	editOtherComments: false,
	pin: true
} );

export const projectReviewerCommentsPermissions = new CommentsPermissions( {
	see: true,
	add: true,
	destroyOwnComments: true,
	editOwnComments: true,
	destroyOtherComments: false,
	editOtherComments: false,
	pin: false
} );

export const nullCommentsPermissions = new CommentsPermissions( {
	see: false,
	add: false,
	destroyOwnComments: false,
	editOwnComments: false,
	destroyOtherComments: false,
	editOtherComments: false,
	pin: false
} );
